import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the Firebase messaging service worker
if ("serviceWorker" in navigator) {
  // Register the new service worker
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log(
        "Firebase Messaging Service Worker registered with scope:",
        registration.scope
      );
    })
    .catch((error) => {
      console.log(
        "Firebase Messaging Service Worker registration failed:",
        error
      );
    });

  // Listen for messages from the service worker
  navigator.serviceWorker.addEventListener("message", (event) => {
    const { action, key, value } = event.data;

    if (action === "set") {
      localStorage.setItem(key, value);
      console.log(`Set ${key} in localStorage`);
    }

    if (action === "navigate" && value) {
      window.location.href = value;
      console.log(`Navigating to: ${value}`);
    }
  });
}
